import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";

import { safeLoad } from "js-yaml";

import Router from "./Router";
import Header from "./components/Header";
import Footer from "./components/Footer";

import devices from "./data/devices.yaml";
import services from "./data/services.yaml";
import doctors from "./data/doctors.yaml";

class App extends Component {
  state = {
    devices: null,
    services: null,
    doctors: null
  };

  componentWillMount() {
    this.fetchData(devices, "devices");
    this.fetchData(services, "services");
    this.fetchData(doctors, "doctors");
  }

  render() {
    if (!this.state.devices || !this.state.services || !this.state.doctors)
      return null;

    return (
      <BrowserRouter>
        <div className="site">
          <div className="siteContent">
            <Header />
            <Router data={this.state} />
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }

  fetchData = (resourceUrl, resourceName) => {
    fetch(resourceUrl)
      .then(data => data.text())
      .then(yamlString => safeLoad(yamlString))
      .then(resource => this.setState({ [resourceName]: resource }));
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js